import React, { useContext, useEffect, useState, useCallback } from "react";
import { Button, message } from "antd";
import MemberProfileContext from "../../reducer";
import { resCatch } from "../../../../../../util/helper";
import { getImportantInfoApi, createImportantInfoApi } from "./api";
import ImportantInfoForm from "./components/ImportantInfoForm";
import ImportantInfoTable from "./components/ImportantInfoTable";

// :: Constants ::
const PAGE_LIMIT = 10;
const INIT_FORM_DATA = { status: "", detail: "" };

const ImportantInformation = () => {
  const {
    state: {
      data: { partner_code },
    },
    dispatch,
  } = useContext(MemberProfileContext);

  // List & Loading states
  const [importantList, setImportantList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);

  // Form visibility & state
  const [showForm, setShowForm] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formData, setFormData] = useState(INIT_FORM_DATA);

  // Unsaved changes check
  const isFormDirty =
    showForm &&
    (Boolean(formData.status && formData.status.trim() !== "") ||
      Boolean(formData.detail && formData.detail.trim() !== ""));

  useEffect(() => {
    dispatch({
      type: "setState",
      payload: { name: "hasUnsavedChanges", value: isFormDirty },
    });
  }, [isFormDirty, dispatch]);

  // ─── API ────────────────────────────────────────────────────────────────────
  const loadImportantInfo = useCallback(
    async (targetPage = 1) => {
      if (!partner_code) return;
      setIsLoading(true);
      try {
        const data = await getImportantInfoApi(partner_code, targetPage, PAGE_LIMIT);
        if (data) {
          setImportantList(data.record || []);
          setTotal(data.total || 0);
          setPage(data.page || 1);
        }
      } catch (error) {
        resCatch(error);
      } finally {
        setIsLoading(false);
      }
    },
    [partner_code]
  );

  useEffect(() => {
    loadImportantInfo(1);
  }, [partner_code, loadImportantInfo]);

  // ─── Form Handlers ───────────────────────────────────────────────────────────
  const openAddForm = useCallback(() => {
    setFormData(INIT_FORM_DATA);
    setShowForm(true);
  }, []);

  const handleCancel = useCallback(() => {
    setShowForm(false);
    setFormData(INIT_FORM_DATA);
  }, []);

  // รวม handler สำหรับทุก field ใน formData ไว้ตัวเดียว
  const handleFormChange = useCallback((field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  }, []);

  const handleSave = useCallback(async () => {
    if (!formData.status?.trim()) return message.error("กรุณากรอกสถานะ Case/สำคัญ");
    if (!formData.detail?.trim()) return message.error("กรุณากรอกข้อมูล Case/สำคัญ");

    setIsSubmitting(true);
    try {
      await createImportantInfoApi({
        partner_code,
        contact_result: formData.status.trim(),
        contact_reason: formData.detail.trim(),
      });
      message.success("เพิ่มข้อมูลสำคัญสำเร็จ");
      handleCancel();
      loadImportantInfo(1);
    } catch (error) {
      resCatch(error);
    } finally {
      setIsSubmitting(false);
    }
  }, [formData, partner_code, handleCancel, loadImportantInfo]);

  // ─── Render ──────────────────────────────────────────────────────────────────
  return (
    <div className="important-information-container" style={{ fontSize: "13px" }}>
      {/* <div className="d-flex justify-content-end mb-2">
        <Button
          type="primary"
          onClick={openAddForm}
          style={{ borderRadius: "6px", fontWeight: "600", fontSize: "13px" }}
        >
          + เพิ่มข้อมูลสำคัญ
        </Button>
      </div> */}

      {/* <ImportantInfoForm
        showForm={showForm}
        formData={formData}
        isSubmitting={isSubmitting}
        onChangeStatus={(val) => handleFormChange("status", val)}
        onChangeDetail={(val) => handleFormChange("detail", val)}
        onCancel={handleCancel}
        onSave={handleSave}
      /> */}

      <ImportantInfoTable
        importantList={importantList}
        isLoading={isLoading}
        page={page}
        limit={PAGE_LIMIT}
        total={total}
        onChangePage={(p) => loadImportantInfo(p)}
      />
    </div>
  );
};

export default ImportantInformation;
